import { performLogout } from 'src/mtska-frontend-app-scaffolding/utils/performLogout';

export const createPollEventHandlers = ({ appConfiguration, logout, doAction } = {}) => ({
    logout_browser: async () => {
        await performLogout({ appConfiguration, logout, doAction, skipAction: true });
    },
});

